module.exports = __webpack_public_path__ + "static/media/pic_winie_01.669398eb.png";